import styled from 'styled-components';
import { IIconProps } from '.';

export const Container = styled.section<IIconProps>`
	display: flex;
	flex:1;
	.material-icons {
		font-size: ${(props => props.fontSize ? `${props.fontSize}px` : '24px')};
	}
`;